export default __webpack_public_path__ + "static/voestalpine-3ae324b2a9cbc98fdcfbbd7bd9312d09.png";